import type { RatingCategory } from '../types/review';

export const RATING_CATEGORY_WEIGHTS = {
  'Chat Quality': 0.2,
  'Image Quality': 0.12,
  'Features': 0.1,
  'Generative Tools': 0.1,
  'User Experience': 0.1,
  'Value/Money': 0.1,
  'Characters': 0.08,
  'Customization': 0.08,
  'Advanced Content': 0.07,
  'Free Trial': 0.05,
} as const;

export type StandardRatingCategory = keyof typeof RATING_CATEGORY_WEIGHTS;

export const STANDARD_RATING_CATEGORIES = Object.keys(
  RATING_CATEGORY_WEIGHTS
) as StandardRatingCategory[];

export function computeOverallRating(categories: RatingCategory[]): number {
  const scores = new Map(categories.map((category) => [category.name, category.score]));

  for (const name of STANDARD_RATING_CATEGORIES) {
    if (!scores.has(name)) {
      throw new Error(`missing rating category: ${name}`);
    }

    const score = scores.get(name);
    if (score === undefined || score < 0 || score > 5) {
      throw new Error('score must be between 0 and 5');
    }
  }

  const weighted = STANDARD_RATING_CATEGORIES.reduce((sum, name) => {
    return sum + (scores.get(name) as number) * RATING_CATEGORY_WEIGHTS[name];
  }, 0);

  return Math.round(weighted * 100) / 100;
}
